module.exports = __webpack_public_path__ + "img/WaterTruck.f88669fa.png";